import React from "react";
import { Button, Modal } from "react-bootstrap";

const ConfirmModal = ({
  shouldShow,
  setShouldShowShow,
  onOkFn,
  modalTitle,
  modalQuestion,
}) => {
  const handleFnRunning = () => {
    setShouldShowShow(false);
    onOkFn();
  };
  return (
      <Modal
        show={shouldShow}
        onHide={() => setShouldShowShow(false)}
        backdrop={false}
      >
        <Modal.Header>
          <Modal.Title> {modalTitle} </Modal.Title>
          <i
            className="fa fa-times mr-auto"
            style={{ fontSize: "16px", cursor: "pointer" }}
            onClick={() => setShouldShowShow(false)}
            aria-hidden="true"
          ></i>
        </Modal.Header>
        <Modal.Body>{modalQuestion}</Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShouldShowShow(false)}>
            لغو
          </Button>
          <Button variant="success" onClick={handleFnRunning} >
            ذخیره تغییرات
          </Button>
        </Modal.Footer>
      </Modal>
  );
};

export default ConfirmModal;
